// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3VYD-","tab":"Tabs_tab__1V9L8","tabActive":"Tabs_tabActive__1vQeY"};